import { Component } from '@angular/core';

@Component({
    selector: 'wci-compact-stats',
    imports: [],
    templateUrl: './compact-stats.component.html',
    styles: ``,
})
export class CompactStatsComponent {}
